module.exports = "/_next/static/images/bg-popup-result-9e0b24f8.png";